import { ActionDTO } from '@envclient/envcore';

export type ChessColor = 'w' | 'b';
// 'timeout' is set server-side when a player fails to move within the turn limit
export type ChessOutcome = 'ongoing' | 'checkmate' | 'stalemate' | 'draw' | 'timeout';

// standard chess starting position
export const CHESS_START_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

/**
 * The whole chess game state submitted on a move. The server treats it opaquely:
 * step() stores it and broadcasts it; all rules are computed on the frontend.
 */
export interface ChessActionDTO extends ActionDTO {
  fen: string;
  outcome: ChessOutcome;
  winnerColor?: ChessColor;
  lastMove?: string; // e.g. 'e2e4', used to highlight the last move
}
